import React from "react";
import * as S from "./index.styles";
import { CitySelectFieldProps } from "./LocationFields.types";

const CitySelectField: React.FC<CitySelectFieldProps> = ({
  value, options, onChange, label, required, border
}) => (
  <S.FieldContainer>
    <S.FieldTitle>
      {label}
      {required && <S.RequiredAsterisk> *</S.RequiredAsterisk>}
    </S.FieldTitle>
    <S.StyledReactSelect
      border={border}
      options={options.map((city) => ({ value: city.name, label: city.name }))}
      value={options.find((city) => city.name === value) ? { value, label: value! } : null}
      onChange={(option: any) => onChange(option?.value ?? "")}
      placeholder={`Select ${label}`}
      isClearable
      classNamePrefix="react-select"
    />
  </S.FieldContainer>
);

export default CitySelectField; 